module.exports = __webpack_public_path__ + "media/images/projects/6-dashboard-1e002cbcb2190a38777ea14316c6cafd.jpg";